module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9.ced87fed.png";